// @ts-strict-ignore
import React from 'react';
import { DropdownMenu } from '@usealloy/component-library';

interface NodeDropdownItemProps {
  onSelect?(e: Event): void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  disabled: boolean;
}

export default function NodeDropdownItem({
  children,
  onSelect,
  style,
  disabled = false,
}: NodeDropdownItemProps) {
  return (
    <DropdownMenu.Item
      disabled={disabled}
      onSelect={e => {
        e.stopPropagation();
        onSelect(e);
      }}
      onClick={e => e.stopPropagation()}
      style={style}
    >
      {children}
    </DropdownMenu.Item>
  );
}
